import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class ConfirmationReturnText extends Component {
  render() {
    return (
      <div className="confirmation_reciept_wrapper">
        <h6 className="text-center">{this.props.returnText}</h6>
      </div>
    );
  }
}

export default ConfirmationReturnText;

ConfirmationReturnText.propTypes = {
  returnText: PropTypes.string,
};
